import { useState, useLayoutEffect, useEffect } from "react";
export function useComponentHeight(ref, active) {
    const isActive = active ?? true;
    const [height, setHeight] = useState(undefined);
    const updateHeight = () => setHeight(ref?.current?.offsetHeight);
    useLayoutEffect(() => {
        window.addEventListener("resize", updateHeight);
        updateHeight();
        return () => window.removeEventListener("resize", updateHeight);
    }, [ref, isActive]);
    useEffect(() => {
        if (isActive && ref)
            updateHeight();
    }, [ref, isActive]);
    return height;
}
